module.exports = __webpack_public_path__ + "static/media/g_bsp.76e1c0ad.mp3";